import React from 'react';
import { Dialog, Intent, Classes, Button } from '@blueprintjs/core';

// --

interface IErrorBoundaryDialogState {
    error: Error | null;
    info?: { componentStack?: any };
}

/**
 * ErrorBoundaryDialog
 * 
 */
export class ErrorBoundaryDialog extends React.Component<React.PropsWithChildren<{}>, IErrorBoundaryDialogState> {

    public override  state: IErrorBoundaryDialogState = {
        error: null,
        info: undefined
    }

    static getDerivedStateFromError(error: Error) {
        // Update state so the next render will show the fallback UI.
        return { error };
    }

    public override componentDidCatch(error: Error, info?: any) {
        console.error('ErrorBoundaryDialog caught error', { error, info });
        this.setState({ error, info });
    }

    protected acknowledgeError = () => {
        this.setState({ error: null, info: null });
    }

    // --

    public override render() {
        const { error } = this.state;

        if (error) {
            return (
                <Dialog
                    icon='error'
                    isOpen={true}
                    onClose={this.acknowledgeError}
                    isCloseButtonShown={true}
                    title="An error has occured"
                    className='ui-error-modal'
                >
                    <div className={Classes.DIALOG_BODY}>
                        <h4>
                            <span className='uk-text-danger uk-text-bold'>[{error.name}]</span>
                            <span className="uk-text-bold uk-margin-small-left">{error.message}</span>
                        </h4>

                        <pre>
                            <div><b>Message:</b></div>
                            {error.message}

                            <div><b>Stack:</b></div>
                            {error.stack}
                        </pre>
                    </div>

                    <div className={Classes.DIALOG_FOOTER}>
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>

                            <Button
                                intent={Intent.PRIMARY}
                                onClick={this.acknowledgeError}
                                text='Close'
                            />
                        </div>
                    </div>
                </Dialog>
            )
        }
        else return this.props.children;
    }
}
